
const videoFeaturedData = [
  {
    id: 1,
    icon: "/assets/images/icons/vendor_network.png",
    heading: "50+ Vendor Network",
    text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  },

  {
    id: 2,
    icon: "/assets/images/icons/manufacturing_processes_1.png",
    heading: "25+ Manufacturing Processes",
    text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  },

  {
    id: 3,
    icon: "/assets/images/icons/development_to_mass_production_support_1.png",
    heading: "Development to Mass Production Support",
    text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  },

  {
    id: 4,
    icon: "/assets/images/icons/thicon.png",
    heading: "Engineering + Manufacturing Support",
    text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  },
  // {
  //   id: uuidv4(),
  //   icon: icon1,
  //   heading: "Cost Optimization Support",
  //   text: "Lorem ipsum dolor sit ame ctetur adipisic ing elit",
  // },
];

export default videoFeaturedData;
